import { cn } from '@/lib/utils';
import { Fragment, type ReactNode } from 'react';

export interface ScenarioRuleDisplayField {
	label: string;
	value: ReactNode;
}

interface ScenarioRuleDisplayItemProps {
	ruleLabel: string;
	fields: ScenarioRuleDisplayField[];
	className?: string;
}

export function ScenarioRuleDisplayItem({
	ruleLabel,
	fields,
	className
}: ScenarioRuleDisplayItemProps) {
	return (
		<div className={cn('bg-transparent', className)}>
			<div className="flex flex-wrap items-center gap-x-3 gap-y-1">
				<p className="inline-flex h-7 shrink-0 items-center text-sm font-semibold text-muted-foreground">
					{ruleLabel}
				</p>
				<div className="min-w-0 flex flex-wrap items-center justify-start text-sm text-foreground">
					{fields.map((field, index) => (
						<Fragment key={`${field.label}-${index}`}>
							{index > 0 && (
								<span className="inline-flex h-7 items-center text-muted-foreground">
									-
								</span>
							)}
							<span className="inline-flex h-7 items-center break-words font-semibold">
								{field.value}
							</span>
						</Fragment>
					))}
				</div>
			</div>
		</div>
	);
}
